import {
  createSlice,
  createAsyncThunk,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";
import http from "../../utils/axios";

export const fetchBanners = createAsyncThunk("banners/fetchBanners", async () => {
  const res = await http.get("/dashboard/banners");
  console.log("Banners API Response:", res);
  console.log("Banners data:", res.data);
  return res;
});

export const createBanner = createAsyncThunk(
  "banners/createBanner",
  async (payload, { rejectWithValue }) => {
          console.log(payload.has('image'))

    try {
      const res = await http.post("/dashboard/banners", payload);
      console.log(res)
      console.log(payload)
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to create banner"
      );
    }
  }
);

export const updateBannerStatus = createAsyncThunk(
  "banners/updateBannerStatus",
  async (payload, { rejectWithValue }) => {
    console.log(payload)
    try {
      console.log(payload)
      const res = await http.post(`/dashboard/banners/${payload.uuid}/toggle-status`, payload);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to update banner status"
      );
    }
  }
);

export const fetchBannerById = createAsyncThunk(
  "banners/fetchBannerById",
  async (uuid, { rejectWithValue }) => {
    try {
      const res = await http.get(`/dashboard/banners/${uuid}`);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch banner details"
      );
    }
  }
);

export const updateBanner = createAsyncThunk(
  "banners/updateBanner",
  async ({ uuid, data }, { rejectWithValue }) => {
    try {
      const res = await http.post(`/dashboard/banners/${uuid}`, data);
      console.log(res)
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to update banner"
      );
    }
  }
);

const bannersSlice = createSlice({
  name: "banner",
  initialState: {
    banners: [],
    pagination: null,
    banner: null,
    bannerCreateStatus: "idle",
    bannerChangeStatus: "idle",
    bannerFetchStatus: "idle",
    bannerUpdateStatus: "idle",
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.fulfilled, (state, action) => {
        console.log("fetchBanners.fulfilled - Full payload:", action.payload);
        console.log("fetchBanners.fulfilled - Data array:", action.payload?.data);
        state.banners = action.payload?.data || [];
        state.pagination = action.payload?.pagination || null;
        console.log("fetchBanners.fulfilled - State banners after update:", state.banners);
      })
      .addCase(updateBannerStatus.pending, (state) => {
        state.bannerChangeStatus = "loading";
      })
      .addCase(updateBannerStatus.rejected, (state) => {
        state.bannerChangeStatus = "failed";
      })
      .addCase(updateBannerStatus.fulfilled, (state, action) => {
        const index = state.banners.findIndex(
          (banner) => banner.id === action.meta.arg.id
        );
        if (index !== -1) {
          state.banners[index].is_enabled =
            action.meta.arg.status === "enable" ? 1 : 0;
        }
        state.bannerChangeStatus = "success";
      })

      .addCase(createBanner.pending, (state) => {
        state.bannerCreateStatus = "loading";
      })
      .addCase(createBanner.fulfilled, (state, action) => {
        state.bannerCreateStatus = "success";
        state.banner = null;
      })
      .addCase(createBanner.rejected, (state) => {
        state.banner = null;
        state.bannerCreateStatus = "failed";
      })

      .addCase(fetchBannerById.pending, (state) => {
        state.bannerFetchStatus = "loading";
      })
      .addCase(fetchBannerById.fulfilled, (state, action) => {
        state.bannerFetchStatus = "success";
        state.banner = action.payload.data;
      })
      .addCase(fetchBannerById.rejected, (state) => {
        state.bannerFetchStatus = "failed";
        state.banner = null;
      })

      .addCase(updateBanner.pending, (state) => {
        state.bannerUpdateStatus = "loading";
      })
      .addCase(updateBanner.fulfilled, (state, action) => {
        state.bannerUpdateStatus = "success";
        // Update the banner in the banners array if it exists
        const index = state.banners.findIndex(
          (banner) => banner.uuid === action.meta.arg.uuid
        );
        if (index !== -1) {
          state.banners[index] = { ...state.banners[index], ...action.payload.data };
        }
        state.banner = action.payload.data;
      })
      .addCase(updateBanner.rejected, (state) => {
        state.bannerUpdateStatus = "failed";
      })

      .addMatcher(isPending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addMatcher(isFulfilled, (state) => {
        state.loading = false;
      })

      .addMatcher(isRejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default bannersSlice.reducer;